var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"initials",style:({
    width: (_vm.size + "px"),
    height: (_vm.size + "px"),
    fontSize: (_vm.fontSize + "px")
  })},[_vm._v(" "+_vm._s(_vm.initials)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }